import React from 'react';
import cn from 'classnames';
import { sendEvent } from 'shared/helpers/requests';
import styles from './FifthBlock.module.scss';
import { ReactComponent as QuestionsIcon } from '../../images/questions.svg';
import { ReactComponent as EggIcon } from '../../images/banner_egg.svg';
import { ReactComponent as ArrowIcon } from '../../images/arrow.svg';
import Boy from '../../images/boy.png';
import { BuyButton } from '../BuyButton';
import { EVENT_SOURCE, EVENT_TYPE, Price } from '../../constants';
import { useLocalStorage } from '../../hooks';

type Props = {
  price: Price;
  isSubjects: boolean;
  isCourses: boolean;
  isSubscription: boolean;
  onValidationOpen(): void;
  goToThirdBlock(): void;
};

export function FifthBlock({
  price,
  isSubjects,
  isCourses,
  isSubscription,
  onValidationOpen,
  goToThirdBlock,
}: Props) {
  const [seenSorry] = useLocalStorage('seenSorry', false);
  return (
    <div className={styles.root}>
      <div className={styles.waveImg} />
      <div className={styles.waveImg} />
      <QuestionsIcon className={styles.questionIcon} />
      <div className={cn(styles.content, isCourses && styles.content_isCourses)}>
        <div className={cn(styles.contentWrapper, seenSorry && styles.contentWrapper_sorry)}>
          <div className={styles.bottomWrapper}>
            <div className={styles.structureWrapper}>
              <p className={styles.structureTitle}>Структура эфира</p>
              <ul className={styles.list}>
                <li>&bull;&nbsp; Приветствие и&nbsp;знакомство</li>
                <li>&bull;&nbsp; Погружение в&nbsp;тему</li>
                <li>&bull;&nbsp; Объяснение темы</li>
                <li>&bull;&nbsp; Практические задания</li>
                <li>&bull;&nbsp; Обратная связь и&nbsp;выводы</li>
              </ul>
              <div className={styles.reward}>
                <p className={styles.rewardTitle}>награда</p>
                <p className={styles.rewardExp}>
                  +30 <EggIcon />
                </p>
              </div>
            </div>
            {!seenSorry && (
              <div className={styles.buyWrapper}>
                <BuyButton
                  text={isCourses ? 'Выбрать курс' : 'Оформить доступ'}
                  onClick={() => {
                    sendEvent({
                      eventSource: isSubjects
                        ? EVENT_SOURCE.SHKOLA
                        : EVENT_SOURCE[isCourses ? 'COURSES' : 'PODPISKA'],
                      eventType:
                        EVENT_TYPE[isSubscription || isSubjects ? 'CLICK_BUY' : 'CLICK_CHOOSE'],
                      eventInfo: JSON.stringify({ place: 'below' }),
                    });
                    if (isCourses) {
                      goToThirdBlock();
                    } else {
                      onValidationOpen();
                    }
                  }}
                />
                {!isCourses && (
                  <p className={styles.buyPrice}>{price.priceForLesson}&nbsp;₽&nbsp;/ занятие</p>
                )}
              </div>
            )}
          </div>
          <ArrowIcon className={styles.arrow} />
          <div className={styles.titleWrapper}>
            <h4 className={styles.title}>Частые вопросы</h4>
            <span className={styles.titleHighlight} />
            <ul className={styles.questionsList}>
              <li>
                <p className={styles.itemTitle}>Как проходит занятие?</p>
                <p className={styles.itemDescription}>
                  Ребенок подключается по&nbsp;специальной ссылке. Урок проходит в&nbsp;прямом эфире
                  и&nbsp;включает разминку, объяснение темы, практические задания и&nbsp;другие
                  активности.
                </p>
              </li>
              <li>
                <p className={styles.itemTitle}>Можно&nbsp;ли посмотреть занятие в&nbsp;записи?</p>
                <p className={styles.itemDescription}>
                  Да, после каждого эфира вам отправляется ссылка на запись&nbsp;&mdash; даже если
                  вы не смогли присутствовать.
                </p>
              </li>
              <li>
                <p className={styles.itemTitle}>Что я&nbsp;получаю после оплаты?</p>
                <p
                  className={styles.itemDescription}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: isCourses
                      ? 'Доступ к курсу, записи после эфиров, полезные материалы.'
                      : `Доступ ко&nbsp;всем новым эфирам и&nbsp;записям предыдущих месяцев, полезные материалы.`,
                  }}
                />
              </li>
              <li>
                <p className={styles.itemTitle}>Какое оборудование необходимо?</p>
                <p className={styles.itemDescription}>
                  Любое устройство&nbsp;&mdash; компьютер, телефон или планшет. Камера
                  и&nbsp;микрофон необязательны.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <img className={styles.boyImg} src={Boy} alt="Мальчик" />
      </div>
    </div>
  );
}
